module.exports = __webpack_public_path__ + "img/login-cube1-1793698374569.png";